import type { LimitsConfig } from './type';

export const limits: LimitsConfig = {
    ignorePermanentChange: true,
};
